import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-easing',
	templateUrl:'./EasingPluginPage.html',
	styles: [],
	styleUrls:['./EasingPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class EasingPluginPage
{
	mdContent_88 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>easing-effects</artifactId>
</dependency>
\`\`\``;
	mdContent_89 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:easing-effects:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_90 = `\`\`\`json
"easing": "*"
\`\`\``;
	mdContent_91 = `\`\`\`java
// Use easing effect enum
String easing = JQEasingEffects.easeInOutQuad.toString();

// Apply to element animation
myComponent.setAttribute("data-easing", easing);

// Available easings include:
// easeInQuad, easeOutQuad, easeInOutQuad
// easeInCubic, easeOutCubic, easeInOutCubic
// easeInElastic, easeOutBounce, and 24 more...
\`\`\``;
	mdContent_92 = `\`\`\`java
// Use easing effect enum
String easing = JQEasingEffects.easeInOutQuad.toString();

// Apply to element animation
myComponent.setAttribute("data-easing", easing);

// Available easings include:
// easeInQuad, easeOutQuad, easeInOutQuad
// easeInCubic, easeOutCubic, easeInOutCubic
// easeInElastic, easeOutBounce, and 24 more...
\`\`\``;
}
